// Deed Documentary Stamps Configuration
export const deedDocumentaryStampsConfig = {
  title: "Deed Documentary Stamps Calculator",
  inputs: [
    {
      id: "propertyLocationHeading",
      title: "Property Location",
      format: "heading"
    },
    {
      id: "propertyLocationMiamiDade", 
      title: "Miami-Dade County",
      format: "radio",
      group: "propertyLocation"
    },
    {
      id: "propertyLocationOther",
      title: "Other Counties",
      format: "radio",
      group: "propertyLocation",
      placeholder: "checked"
    },
    {
      id: "singleFamilyHeading",
      title: "Single Family Dwelling",
      format: "heading",
      conditionKey: "propertyLocation",
      conditionValue: "propertyLocationMiamiDade"
    },
    {
      id: "singleFamilyYes", 
      title: "Yes",
      format: "radio",
      group: "singleFamily",
      conditionKey: "propertyLocation",
      conditionValue: "propertyLocationMiamiDade"
    },
    {
      id: "singleFamilyNo",
      title: "No",
      format: "radio",
      group: "singleFamily",
      conditionKey: "propertyLocation",
      conditionValue: "propertyLocationMiamiDade"
    },
    {
      id: "salesPrice",
      title: "Sales Price",
      format: "currency"
    },
    {
      id: "loanAmount",
      title: "Loan Amount",
      format: "currency"
    },
  ],
  outputs: [
    {
      id: "surtax",
      title: "Surtax",
      format: "currency"
    },
    {
      id: "mortgageDocStamps",
      title: "Florida Mortgage Doc Stamps",
      format: "currency"
    },
    {
      id: "intangibleTax",
      title: "Florida Intangible Tax",
      format: "currency"
    },
    {
      id: "deedDocStamps",
      title: "Deed Doc Stamps",
      format: "currency"
    }
  ]
};

// Deed Documentary Stamps Calculator Calculation Function
export const calculateDeedDocumentaryStamps = (inputs) => {
  const { propertyLocation, singleFamily, salesPrice, loanAmount } = inputs;

  const transferTaxRate = propertyLocation === "propertyLocationMiamiDade" ? 0.6 : 0.7;
  const adjSalesPrice = Math.ceil(Math.round(salesPrice) / 100) * 100;
  const loanAmountInput = Math.ceil(Math.round(loanAmount) / 100) * 100;

  const surtax = Math.round((adjSalesPrice) * 0.45) / 100;
  const mortgageDocStamps = Math.round((loanAmountInput) * 0.35) / 100;
  const intangibleTax = Math.round(loanAmount * 0.2) / 100;

  const deedDocStamps = Math.round(adjSalesPrice * transferTaxRate) / 100;

  return {
    surtax,
    mortgageDocStamps,
    intangibleTax,
    deedDocStamps
  };
};
